import {
    BZ2_MESSAGE_YOU_GAVE_REVIEW_LINK_LABEL,
    BZ2_MESSAGE_YOU_GAVE_REVIEW_TO_link,
    BZ2_MESSAGE_YOU_GOT_REVIEW_FROM_link,
    BZ2_MESSAGE_YOU_GOT_REVIEW_LINK_LABEL,
} from 'mk/autogenerated/translations/ReviewMessage.ef110c63181b8c1e65e67de27f6bef29'
import { Message, Type } from 'mk2/apps/bazaar/components/Message';
import { BazaarMessageType, ReviewEntity, ReviewRole } from 'mk2/apps/bazaar/schemas';
import {
    bazaarMyReviewsFromBuyersUrl,
    bazaarMyReviewsFromSellersUrl,
    bazaarSellerReviewsFromBuyersUrl,
    bazaarSellerReviewsFromSellersUrl,
} from 'mk2/apps/bazaar/urls';
import { Interpolate } from 'mk2/components/Interpolate';
import { Link } from 'mk2/components/Link';
import { url } from 'mk2/helpers/urls';
import React from 'react';

interface OwnProps {
    className?: string;
    review: ReviewEntity;
    type: Type;
    showProduct?: boolean;
}

type Props = OwnProps;

export const ReviewMessage: React.FunctionComponent<Props> = React.memo(({
    className, review, type, showProduct = false,
}) => {
    const message =
        type === Type.RECEIVED ? (
            <Interpolate
                i18nKey={BZ2_MESSAGE_YOU_GOT_REVIEW_FROM_link}
                link={
                    <Link
                        to={
                            review.role === ReviewRole.SELLER
                                ? // ako kupujuca dostala hodnotenie od predajcu
                                  url(bazaarMyReviewsFromSellersUrl, {username: review.reviewed.username})
                                : // ako predajca dostala hodnotenie od nakupujucej
                                  url(bazaarMyReviewsFromBuyersUrl, {username: review.reviewed.username})
                        }
                    >
                        {BZ2_MESSAGE_YOU_GOT_REVIEW_LINK_LABEL}
                    </Link>
                }
            />
        ) : (
            <Interpolate
                i18nKey={BZ2_MESSAGE_YOU_GAVE_REVIEW_TO_link}
                link={
                    <Link
                        to={
                            review.role === ReviewRole.SELLER
                                ? // ako predajca dala hodnotenie kupujucej
                                  url(bazaarSellerReviewsFromSellersUrl, {username: review.reviewed.username})
                                : // ako nakupujca dala hodnotenie predajcovi
                                  url(bazaarSellerReviewsFromBuyersUrl, {username: review.reviewed.username})
                        }
                    >
                        {BZ2_MESSAGE_YOU_GAVE_REVIEW_LINK_LABEL}
                    </Link>
                }
            />
        );

    const author = type === Type.RECEIVED ? review.reviewer : review.reviewed;
    const messageType = review.role === ReviewRole.SELLER
        ? BazaarMessageType.FromSeller
        : BazaarMessageType.FromBuyer;

    return (
        <Message
            className={className}
            author={author}
            sentDate={review.date}
            message={message}
            messageType={messageType}
            type={type}
            product={review.product}
            showProduct={showProduct}
            review={review}
        />
    );
});

ReviewMessage.displayName = 'ReviewMessage';
